import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectSeasonEntity } from "~components/SelectSeasonEntity/SelectSeasonEntity";
import { ImageTypes } from "~enums/imageTypes";
import type { Entity } from "~types/entity";
import type { ColumnComponentProperties } from "../../types";
import { StyledCompetitorCell } from "./Columns.styles";

type Props = ColumnComponentProperties & {
  entity: Entity;
  isHome: boolean;
  oppositeEntity: Entity;
};

export const EntityColumn = ({ entity, isHome, oppositeEntity, editMode, fixtureId, updateFixture, isUpdatePending }: Props) => {
  const { formatMessage } = useIntl();

  if (editMode) {
    const value = isEmpty(entity) ? null : { label: entity.nameFullLocal, value: entity.entityId };

    const onChangeHandler = (competitorOption: InfinitySelectOption | null) => {
      const competitors: {
        isHome: boolean;
        entityId: string;
      }[] = [];
      if (!isEmpty(competitorOption) && !isEmpty(competitorOption.value)) {
        competitors.push({ entityId: competitorOption.value, isHome });
      }
      if (!isEmpty(oppositeEntity?.entityId)) {
        competitors.push({
          entityId: oppositeEntity.entityId,
          isHome: !isHome,
        });
      }

      updateFixture({
        fixtureId,
        upsertData: {
          competitors: competitors,
        },
      });
    };

    return (
      <SelectSeasonEntity
        disabled={isUpdatePending}
        placeholder={formatMessage({
          id: `fixtureListPage.table.column.editMode.${isHome ? "homeCompetitor" : "awayCompetitor"}.placeholder`,
        })}
        value={value}
        disabledOptionValues={isEmpty(oppositeEntity?.entityId) ? [] : [oppositeEntity.entityId]}
        onChange={onChangeHandler}
        rightAligned={isHome}
      />
    );
  }

  return (
    <StyledCompetitorCell $isReverse={isHome}>
      {entity && <DataTableImageColumn images={entity?.images} imageTypes={[ImageTypes.Logo, ImageTypes.LogoAlternate]} />}
      <span>{entity?.nameFullLocal}</span>
    </StyledCompetitorCell>
  );
};
